import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const CloseIconMap: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.77734 9.19337L0.000151038 16.9706L1.41436 18.3848L9.19156 10.6076L16.9706 18.3866L18.3848 16.9724L10.6058 9.19337L18.3849 1.41421L16.9707 0L9.19156 7.77916L1.41421 0.00181246L0 1.41603L7.77734 9.19337Z" fill={fill}/>
  </svg>

);

export default CloseIconMap;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const CloseIconMap: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.77734 9.19337L0.000151038 16.9706L1.41436 18.3848L9.19156 10.6076L16.9706 18.3866L18.3848 16.9724L10.6058 9.19337L18.3849 1.41421L16.9707 0L9.19156 7.77916L1.41421 0.00181246L0 1.41603L7.77734 9.19337Z" fill={fill}/>
  </svg>

);

export default CloseIconMap;
